<script setup>
import { useRoute } from 'vue-router';
import { useCopilotPrompts } from 'dashboard/composables/useCopilotPrompts';
import Icon from '../icon/Icon.vue';

defineProps({
  hasAssistants: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['useSuggestion']);
const route = useRoute();

const { promptOptions } = useCopilotPrompts();
</script>

<template>
  <div class="flex-1 flex flex-col gap-6 px-2">
    <div class="flex flex-col items-center text-center pt-6 pb-1">
      <div
        class="relative size-14 rounded-full bg-[radial-gradient(circle_at_32%_28%,#b8a5ff,#6e56cf_58%,#4636a3)] shadow-[0_0_0_6px_rgba(110,86,207,0.14),0_0_36px_4px_rgba(110,86,207,0.25)]"
      >
        <div class="absolute inset-5 rounded-full bg-white/70 blur-md" />
      </div>
      <div class="space-y-1 mt-5">
        <h3 class="text-lg font-semibold text-n-slate-12">
          {{ $t('CAPTAIN.COPILOT.PANEL_TITLE') }}
        </h3>
        <p class="text-sm text-n-slate-11 leading-6 max-w-[32ch]">
          {{ $t('CAPTAIN.COPILOT.KICK_OFF_MESSAGE') }}
        </p>
      </div>
    </div>
    <div v-if="!hasAssistants" class="w-full space-y-2 text-center">
      <p class="text-sm text-n-slate-11 leading-6">
        {{ $t('CAPTAIN.ASSISTANTS.NO_ASSISTANTS_AVAILABLE') }}
      </p>
      <router-link
        :to="{
          name: 'captain_assistants_create_index',
          params: {
            accountId: route.params.accountId,
          },
        }"
        class="text-n-slate-11 underline hover:text-n-slate-12"
      >
        {{ $t('CAPTAIN.ASSISTANTS.ADD_NEW') }}
      </router-link>
    </div>
    <div v-else class="w-full space-y-2">
      <button
        v-for="prompt in promptOptions"
        :key="prompt.label"
        class="w-full flex items-start gap-3 p-3 rounded-xl border border-n-weak bg-n-alpha-1 shadow-sm text-left hover:border-n-violet-9 transition-colors"
        @click="emit('useSuggestion', prompt.prompt)"
      >
        <span
          class="size-8 rounded-lg bg-n-violet-9/10 text-n-violet-11 flex items-center justify-center flex-shrink-0"
        >
          <Icon :icon="prompt.icon" class="size-4" />
        </span>
        <span class="flex flex-col min-w-0">
          <span class="text-sm font-medium text-n-slate-12">
            {{ prompt.label }}
          </span>
          <span class="text-xs text-n-slate-10">
            {{ prompt.description }}
          </span>
        </span>
      </button>
    </div>
  </div>
</template>
